import styled from '@emotion/styled'
import { Box, Switch, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const ChartSectionContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const HeaderContainer = styled(Box)`
  padding: 24px;
  display: flex;
  justify-content: space-between;
`

export const Header = styled(Typography)`
  ${typography.up1.regularSerif}
`

export const HeaderFilters = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`
export const ChartContainer = styled(Box)`
  background-color: ${colors.background.paper};
  width: 100%;
`

export const ChartHeader = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const AggregateToggle = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
  color: ${colors.copy.paragraphDark};
`

export const TitleToggleContainer = styled(Box)`
  align-items: center;
  display: flex;
  gap: 12px;
`

export const ToggleLabel = styled.span`
  ${typography.baseline.regularSans}
`

export const StyledSwitch = styled(Switch)`
  .MuiSwitch-switchBase {
    color: ${colors.interactive.secondaryEnabled};

    &.Mui-checked {
      color: ${colors.interactive.primaryEnabled};
    }

    &.Mui-checked + .MuiSwitch-track {
      background-color: ${colors.interactive.primaryEnabled};
    }
  }

  .MuiSwitch-track {
    background-color: ${colors.interactive.primaryEnabled};
  }
`

export const OverallProgressChip = styled.div`
  align-items: center;
  background-color: ${colors.feedback.infoLight};
  border-radius: 4px;
  color: ${colors.copy.paragraphDark};
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  min-width: 200px;
  height: 62px;
`

export const ChipProgressText = styled.div`
  ${typography.down1.regularSans}
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 1px;
`

export const ChipTotalText = styled(Typography)`
  ${typography.up1.regularSerif}
`

export const ChartOverviewHeader = styled(Box)`
  ${typography.up1.regularSerif}
`

// Tooltip styles

export const TooltipContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color }) => ({
  backgroundColor: colors.background.paper,
  boxShadow: '0px 0px 5px 5px rgba(0, 0, 0, 0.1)',
  padding: '16px',
  borderLeft: `6px solid ${color || colors.copy.headerDark}`,
  borderRadius: '4px',
  minHeight: '200px',
  maxWidth: '300px',
  alignContent: 'center',
}))

export const OverviewBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding-left: 8px;
  justify-content: space-between;
`

export const DataWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const IconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color?: string }>(({ color }) => ({
  position: 'relative',
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    backgroundColor: color || colors.copy.headerDark,
    opacity: 0.3,
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention
  '& .MuiSvgIcon-root': {
    position: 'relative',
    zIndex: 1,
    color: color || colors.copy.headerDark,
    width: '14px',
    height: '14px',
  },
}))

export const Datapoint = styled(Typography)`
  ${typography.up2.regularSerif};
  color: ${colors.copy.paragraphDark};
`

export const Label = styled(Typography)`
  ${typography.down1.regularSans};
  color: ${colors.copy.paragraphDark};
`

export const GranteeGoal = styled(Typography)`
  ${typography.baseline.regularSans};
  color: ${colors.copy.paragraphDark};
`

export const DateValue = styled(Typography)`
  ${typography.down1.regularSans};
  color: ${colors.copy.paragraphDark};
`
export const GranteeName = styled(Typography)`
  ${typography.up1.regularSerif};
  color: ${colors.copy.paragraphDark};
`

export const Row = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`
